export const fetchTripAdvanceURL = () => {
  return '/finance/advance-search-trip';
};

// NPC (Non-Payable Challan) slab-rate configuration
export const fetchNpcConfigURL = () => {
  return '/finance/npc-config/';
};

// NOTE: REACT_APP_API_HOST already ends with /v2, so these paths are relative
// to it (no leading /v2 — that would resolve to /v2/v2/...).
export const saveNpcConfigURL = () => {
  return '/finance/npc-config/';
};

// NPC change-request approval queue
export const fetchNpcApprovalsURL = (query) => {
  return `/finance/npc-approvals/${query ? `?${query}` : ''}`;
};

export const approveNpcRequestURL = (npcRecordId) => {
  return `/finance/npc-approvals/${npcRecordId}/approve/`;
};

export const rejectNpcRequestURL = (npcRecordId) => {
  return `/finance/npc-approvals/${npcRecordId}/reject/`;
};

// Raise an NPC change request from the trip screen
export const npcChangeRequestURL = () => {
  return '/finance/npc-change-request';
};

export const updateTripChargeURL = () => {
  return '/finance/save-trip-charge';
};

export const verifyOTPURL = () => {
  return '/finance/verify-trip-charge-otp';
};

export const sendOTPURL = () => {
  return '/finance/send-trip-charge-otp';
};

export const addAdvanceURL = () => {
  return '/finance/add-new-advance';
};

export const fetchTripChargesURL = () => {
  return '/finance/tripcharge-checklist';
};

// Third Party charges (visibility / P&L only). Host already carries the /v2
// prefix, so the path here maps to /v2/finance/third-party-charge/.
export const thirdPartyChargeURL = (tripCode) => {
  return `/finance/third-party-charge/${
    tripCode ? `?trip_code=${tripCode}` : ''
  }`;
};

// PUT / DELETE require an {id} segment by the DRF router but it is ignored —
// the contract says to pass any integer.
export const thirdPartyChargeByIdURL = (id = 1) => {
  return `/finance/third-party-charge/${id}/`;
};

export const fetchRequestStatusURL = (search) => {
  // return `/finance/advance-requests${search ? '?' + search : ''}`;
  return `/finance/advance-requests${search ? search : ''}`;
};

export const updateRequestStatusURL = () => {
  return '/finance/advance-request-action';
};

export const tripAdvanceHistoryURL = (tripCode) => {
  return `/finance/trip-advance-history/${tripCode}`;
};

export const tripChagresByCodeURL = (tripCode) => {
  return `/finance/trip-charge-details/${tripCode}`;
};

export const fetchPrevTripChargesURL = (tripCode) => {
  return `/finance/trip-revenue-details/${tripCode}`;
};

export const fetchUploadFinanceURL = () => {
  return `/finance/upload-other-payments`;
};

export const uploadFinanceURL = () => {
  return `finance/upload-other-payments`;
};

export const closeRequestURL = () => {
  return `finance/close-diesel-request`;
};

export const addBeneficiaryURL = () => {
  return '/finance/add-beneficiary';
};

export const fetchAdvancePaymentHistoryURL = (tripId, vendorID) => {
  return `/finance/trip-advance-history?trip_id=${tripId}&vendor_id=${vendorID}`;
};

//passbook
export const getPassbookDataURL = (queryParams) => {
  return `/finance/send-to-passbook/${queryParams ? queryParams : ''}`;
};

export const holdPartnerPassbookPaymentURL = () => {
  return `/finance/passbook/toggle_payment_hold/`;
};

export const addPassbookCreditURL = () => {
  return `/finance/passbook/add_credit/`;
};

export const addPassbookDebitURL = () => {
  return `/finance/passbook/add_debit/`;
};

export const sendPassbookDataURL = () => {
  return `/finance/send-to-passbook/`;
};

export const customFilterViewURL = () => {
  return '/general/filter-preset/';
};

export const stpSendForApprovalURL = () => {
  return `/finance/payment-approvals/send-approve/`;
};

export const getRefreshOrderDetailsDataURL = () => {
  return `/customer/refresh-order-invoice-details/`;
};

export const getPassbookBalancesDataURL = (entityId) => {
  return `/finance/passbook/balance/?entity=${entityId}`;
};

export const payExternalPaymentPartyURL = () => {
  return `/finance/external-payment-party/`;
};

export const getAdjustmentSummaryURL = (searchStr) => {
  return `/finance/adjustment-summary${searchStr}`;
};

export const getVendorOrdersURL = (vendor_id) => {
  return `/finance/adjustment-summary/?vendor_id=${vendor_id}`;
};
// Debit Tagging
export const getDebitOrderMappingURL = (queryString) => {
  return `/finance/debit-tagging/order-mapping/${
    queryString ? '?' + queryString : ''
  }`;
};

export const getDebitLegendMappingURL = (queryString) => {
  return `/finance/debit-tagging/legend-mapping/${
    queryString ? '?' + queryString : ''
  }`;
};

export const getDebitCustomersURL = () => {
  return `/finance/debit-tagging/customers/`;
};

export const searchDebitOrdersURL = (customerId, query) => {
  return `/finance/debit-tagging/order-search/?customer_id=${customerId}&q=${encodeURIComponent(
    query,
  )}`;
};

export const submitDebitOrderMappingURL = () => {
  return `/finance/debit-tagging/order-mapping/submit/`;
};

export const submitDebitLegendMappingURL = () => {
  return `/finance/debit-tagging/legend-mapping/submit/`;
};

export const rejectDebitLegendEntryURL = () => {
  return `/finance/debit-tagging/legend-mapping/reject/`;
};

export const submitDebitRejectedEntryURL = () => {
  return `/finance/debit-tagging/rejected/submit/`;
};

export const validateDebitOrderIdsURL = () => {
  return `/finance/debit-tagging/validate-orders/`;
};

export const getDebitWarehousesByCustomerURL = (customerId) => {
  return `/finance/debit-tagging/warehouses/?customer_id=${customerId}`;
};

export const getDebitInitialDataURL = () => {
  return `/finance/delta-debit-tagging/initial/`;
};

export const getDebitSearchURL = (page = 1) => {
  return `/finance/delta-debit-tagging/search/?page=${page}`;
};

export const searchDeltaDebitOrdersURL = () => {
  return `/finance/delta-debit-tagging/search_orders/`;
};

export const getDebitEntryDetailsURL = (id) => {
  return `/finance/delta-debit-tagging/${id}/details/`;
};

export const getRejectedDebitEntryDetailsURL = (id) => {
  return `/finance/delta-debit-tagging/${id}/details/?sub_tab=rejected`;
};

export const submitDebitOrdersMappingURL = () => {
  return `/finance/delta-debit-tagging/orders-mapping/`;
};

export const downloadDebitTaggingURL = () => {
  return `/finance/delta-debit-tagging/download/`;
};

export const deltaDebitLegendTaggingURL = () => {
  return `/finance/delta-debit-tagging/legend-tagging/`;
};

export const deltaDebitLegendRejectURL = () => {
  return `/finance/delta-debit-tagging/legend-reject/`;
};

export const addDebitEntryCommentURL = () => {
  return `/finance/delta-debit-tagging/comment/`;
};

export const uploadPaymentAdviceURL = (debitEntryId) => {
  return `/finance/delta-debit-tagging/${debitEntryId}/payment-advice/upload/`;
};

export const removePaymentAdviceURL = (debitEntryId) => {
  return `/finance/delta-debit-tagging/${debitEntryId}/payment-advice/remove/`;
};

export const downloadOrderMappingTemplateURL = () => {
  return `/finance/delta-debit-tagging/order-mapping/template/`;
};

export const uploadOrderMappingExcelURL = () => {
  return `/finance/delta-debit-tagging/order-mapping/upload/`;
};
